<template>
  <div>
    <customize-page
      label-position="left"
      inline
      hide-operate
      :loading="loading"
      :data="rows"
      :columns="columns"
      :form-config="formConfig"
      :filter-obj="filterObj"
      :pagination="pagination"
      @submit.native.prevent="search"
    >
      <div slot="footer">
        <el-button type="primary" :disabled="!ownerReady" @click="search"
          >查询</el-button
        >
        <el-button
          v-if="can('create')"
          type="primary"
          data-test="create-order"
          @click="creating = true"
          >创建</el-button
        >
        <el-button v-if="can('create')" type="primary" data-test="import-orders" @click="$router.push({ name: 'warehouseReceiptOutboundImport' })">导入</el-button>
      </div>
    </customize-page>
    <trace-log-dialog
      v-if="traceDocNo"
      :key="traceDocNo"
      :doc-no="traceDocNo"
      @close="traceDocNo = ''"
    />
    <order-create-dialog
      v-if="creating"
      kind="outbound"
      :customers="customers"
      :bound-customer-id="boundCustomerId"
      :initial-customer-id="filterObj.customerId"
      @close="creating = false"
      @saved="createdOrder"
    />
    <hezhu-create-dialog
      v-if="hezhuOrder"
      kind="outbound"
      :order="hezhuOrder"
      @close="hezhuOrder = null"
      @saved="hezhuSaved"
    />
    <el-dialog
      v-if="manualReleaseOrder"
      :visible="true"
      title="手工放行"
      width="550px"
      @close="manualReleaseOrder = null"
    >
      <el-form :model="manualReleaseForm" label-width="110px">
        <el-form-item label="核注单编号">
          <el-input
            v-model="manualReleaseForm.businessId"
            data-test="manual-business-id"
          />
        </el-form-item>
        <el-form-item label="单一窗口编号">
          <el-input
            v-model="manualReleaseForm.singleWindowNo"
            data-test="manual-single-window-no"
          />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="manualReleaseOrder = null">取消</el-button>
        <el-button
          type="primary"
          data-test="confirm-manual-release"
          :loading="busy === 'manualRelease'"
          @click="manualRelease"
          >确定</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      v-if="detail"
      :visible="true"
      title="单据详情"
      width="70%"
      @close="detail = null"
    >
      <p>
        {{ detail.outboundOrderId }} / {{ detail.customerId }} /
        {{ statusName(detail.status) }} / {{ wmsName(detail.wmsStatus) }}
      </p>
      <el-alert
        v-if="detail.transferOperationId"
        type="info"
        :closable="false"
        :title="
          '货权转移专用单据（任务：' +
            detail.transferOperationId +
            '），请人工下发仓库；无需核注，不可取消。'
        "
      />
      <p>客户单号：{{ detail.customerOrderNo }}</p>
      <el-table :data="detail.items" size="mini" max-height="50vh" border>
        <el-table-column
          v-for="column in detailColumns"
          :key="column[0]"
          :prop="column[0]"
          :label="column[1]"
          min-width="155"
        />
      </el-table>
      <span slot="footer"
        ><el-button @click="detail = null">关闭</el-button></span
      >
    </el-dialog>
    <el-dialog
      v-if="hezhuDetail"
      :visible="true"
      title="核注详情"
      width="70%"
      @close="hezhuDetail = null"
    >
      <he-zhu-order-detail
        :key="hezhuDetail"
        :hezhu-order-id="hezhuDetail"
        :with-card="false"
      />
    </el-dialog>
  </div>
</template>

<script>
import { OrderStatus, WmsStatus } from "./receiptEnums";
import api from "@/api/warehouseReceipt";
import heZhuApi from "@/api/heZhuApi";
import hasPermission from "@/directive/permissionButton/hasPermission";
import owner from "./owner";
import TraceLogDialog from "./TraceLogDialog";
import OrderCreateDialog from "./OrderCreateDialog";
import HezhuCreateDialog from "./HezhuCreateDialog";
import HeZhuOrderDetail from "@/views/purchase/hezhu_order/HeZhuOrderDetail";

import CustomizePage from "@/components/customize-page";
import Page from "@/mixin/Page";
import {
  statuses,
  statusTagTypes,
  wmsStatuses,
  wmsStatusTagTypes
} from "./orderStatuses";

export default {
  name: "OutboundOrders",
  components: {
    CustomizePage,
    TraceLogDialog,
    OrderCreateDialog,
    HezhuCreateDialog,
    HeZhuOrderDetail
  },
  mixins: [owner, Page],
  data() {
    return {
      columns: [
        { title: "客户单号", key: "customerOrderNo", minWidth: 180 },
        { title: "出库单号", key: "outboundOrderId", minWidth: 230 },
        { title: "货主", key: "customerId", minWidth: 130 },
        { title: "仓库", key: "warehouseId", width: 90 },
        {
          title: "业务状态",
          minWidth: 100,
          render: (h, { row }) => (
            <el-tag type={statusTagTypes[row.status] || ""}>
              {this.statusName(row.status)}
            </el-tag>
          )
        },
        {
          title: "仓库状态",
          minWidth: 140,
          render: (h, { row }) => (
            <el-tag type={wmsStatusTagTypes[row.wmsStatus] || ""}>
              {this.wmsName(row.wmsStatus)}
            </el-tag>
          )
        },
        { title: "创建时间", key: "gmtCreate", minWidth: 180 },
        {
          title: "操作",
          fixed: "right",
          width: 240,
          render: (h, { row }) => (
            <div>
              <el-button
                type="text"
                data-test="detail"
                disabled={!!this.busy}
                onClick={() => this.showDetail(row)}
              >
                详情
              </el-button>
              {this.can("createHezhu") && this.canHezhu(row) && (
                <el-button
                  type="text"
                  disabled={!!this.busy}
                  onClick={() => {
                    this.hezhuOrder = row;
                  }}
                >
                  生成核注
                </el-button>
              )}
              {row.hezhuOrderId && (
                <el-button
                  type="text"
                  disabled={!!this.busy}
                  onClick={() => this.showHezhu(row)}
                >
                  查看核注
                </el-button>
              )}
              {this.can("declare") && this.canDeclare(row) && (
                <el-button
                  type="text"
                  data-test="declare"
                  disabled={!!this.busy}
                  onClick={() => this.declare(row)}
                >
                  申报
                </el-button>
              )}
              {this.can("manualRelease") && this.canDeclare(row) && (
                <el-button
                  type="text"
                  data-test="manual-release"
                  disabled={!!this.busy}
                  onClick={() => this.openManualRelease(row)}
                >
                  手工放行
                </el-button>
              )}
              {this.can("sendWms") && this.canSend(row) && (
                <el-button
                  type="text"
                  data-test="sendWms"
                  disabled={!!this.busy}
                  onClick={() => this.act(row, "sendWms", "确认下发仓库？")}
                >
                  {row.wmsStatus === WmsStatus.INIT ? "下发仓库" : "重新下发"}
                </el-button>
              )}
              {this.can("cancel") && this.canCancel(row) && (
                <el-button
                  type="text"
                  data-test="cancel"
                  disabled={!!this.busy}
                  onClick={() =>
                    this.act(
                      row,
                      "cancel",
                      row.wmsStatus !== WmsStatus.INIT
                        ? "需要仓库确认无实出并撤单成功后才能取消和释放占用，确认申请撤单？"
                        : "确认整单取消？关联核注草稿将同时作废。"
                    )
                  }
                >
                  取消
                </el-button>
              )}
              <el-button
                type="text"
                data-test="trace-log"
                onClick={() => {
                  this.traceDocNo = row.outboundOrderId;
                }}
              >
                轨迹日志
              </el-button>
            </div>
          )
        }
      ],
      filterObj: { customerId: "", orderId: "", status: "" },
      rows: [],
      loading: false,
      busy: "",
      error: "",
      loadError: "",
      creating: false,
      detail: null,
      traceDocNo: "",
      hezhuOrder: null,
      hezhuDetail: null,
      manualReleaseOrder: null,
      manualReleaseForm: { businessId: "", singleWindowNo: "" },
      requestId: 0
    };
  },
  computed: {
    formConfig() {
      return [
        {
          data: [
            {
              label: "货主",
              model: "customerId",
              type: "SELECT",
              disabled: !this.ownerReady || !!this.boundCustomerId,
              props: {
                remote: true,
                remoteMethod: q =>
                  this.searchOwners(q, this.filterObj.customerId),
                loading: this.customerLoading,
                data: this.customers.map(c => ({
                  value: c.customerId,
                  label: c.name
                }))
              }
            },
            {
              label: "单号",
              model: "orderId",
              type: "INPUT",
              props: { clearable: true }
            },
            {
              label: "业务状态",
              model: "status",
              type: "SELECT",
              props: {
                data: Object.entries(statuses)
                  .filter(([key]) => key !== OrderStatus.INBOUND_FINISHED)
                  .map(([value, label]) => ({ value, label }))
              }
            }
          ]
        }
      ];
    },
    detailColumns() {
      return [
        ["itemNo", "商品料号"],
        ["skuName", "商品名称"],
        ["batchId", "批次库存ID"],
        ["quantity", "原始申请数量"],
        ["finalShippedQty", "最终实出数量"],
        ["currentOccupiedQty", "当前占用数量"]
      ];
    }
  },
  async created() {
    await this.reload();
    this.openLinkedOrder();
  },
  activated() {
    if (this.ownerReady) {
      this.search();
    }
  },
  watch: {
    "$route.query.outboundOrderId"() {
      this.openLinkedOrder();
    }
  },
  beforeDestroy() {
    this.requestId++;
  },
  methods: {
    openLinkedOrder() {
      const orderId =
        this.$route && this.$route.query && this.$route.query.outboundOrderId;
      if (this.ownerReady && typeof orderId === "string" && orderId) {
        this.filterObj.orderId = orderId;
        this.search();
        this.showDetail({ outboundOrderId: orderId });
      }
    },
    can(action) {
      return (
        this.ownerReady &&
        !this.boundCustomerId &&
        hasPermission.hasPermission(this.$route, action)
      );
    },
    statusName(value) {
      return statuses[value] || value;
    },
    wmsName(value) {
      return wmsStatuses[value] || value;
    },
    canHezhu(row) {
      if (row.transferOperationId) {
        return false;
      }
      return (
        row.status === OrderStatus.CREATED &&
        !row.hezhuOrderId &&
        !String(row.wmsStatus).startsWith("WMS_CANCEL_")
      );
    },
    canDeclare(row) {
      if (row.transferOperationId) {
        return false;
      }
      return (
        [OrderStatus.WAIT_DECLARE, OrderStatus.DECLARED].includes(row.status) &&
        !!row.hezhuOrderId &&
        !String(row.wmsStatus).startsWith("WMS_CANCEL_")
      );
    },
    canSend(row) {
      if (row.transferOperationId) {
        return (
          row.status === OrderStatus.CREATED &&
          [
            WmsStatus.INIT,
            WmsStatus.WMS_CREATE_EXCEPTION,
            WmsStatus.WMS_SEND_UNKNOWN
          ].includes(row.wmsStatus)
        );
      }
      return (
        row.status !== OrderStatus.CANCELED &&
        [
          WmsStatus.INIT,
          WmsStatus.WMS_CREATE_EXCEPTION,
          WmsStatus.WMS_SEND_UNKNOWN
        ].includes(row.wmsStatus)
      );
    },
    canCancel(row) {
      if (row.transferOperationId) {
        return false;
      }
      return (
        [OrderStatus.CREATED, OrderStatus.WAIT_DECLARE].includes(row.status) &&
        row.wmsStatus !== WmsStatus.STOCKOUT_FINISHED
      );
    },
    async reload() {
      if (await this.initOwner()) {
        this.filterObj.customerId = this.boundCustomerId;
        this.search();
      }
    },
    handleSizeChange(size) {
      this.pagination.pageSize = size;
      this.search();
    },
    async fetch() {
      if (!this.ownerReady) return;
      const id = ++this.requestId;
      this.loadError = "";
      this.loading = true;
      this.rows = [];
      try {
        const res = await api.outbound.pageQuery({
          customerId: this.boundCustomerId || this.filterObj.customerId,
          outboundOrderId: this.filterObj.orderId,
          status: this.filterObj.status,
          pageIndex: this.pagination.currentPage,
          pageSize: this.pagination.pageSize
        });
        if (id !== this.requestId) return;
        this.rows = res.items || [];
        this.pagination.totalCount = res.page.totalCount;
      } catch (error) {
        if (id === this.requestId) this.loadError = "单据加载失败，请刷新重试";
      } finally {
        if (id === this.requestId) this.loading = false;
      }
    },
    async showDetail(row) {
      if (this.busy) return;
      this.busy = "detail";
      this.error = "";
      try {
        const detail = await api.outbound.load(row.outboundOrderId);
        const occupied = {};
        let pageIndex = 1,
          res;
        do {
          res = await api.expiry.occupancy({
            customerId: detail.customerId,
            outboundOrderId: detail.outboundOrderId,
            pageIndex,
            pageSize: 100
          });
          (res.items || []).forEach(item => {
            occupied[item.stockId] =
              (occupied[item.stockId] || 0) + item.occupiedQty;
          });
          pageIndex++;
        } while ((pageIndex - 1) * 100 < res.page.totalCount);
        detail.items = (detail.items || []).map(item => ({
          ...item,
          currentOccupiedQty: occupied[item.stockId] || 0,
          finalShippedQty:
            detail.wmsStatus === WmsStatus.STOCKOUT_FINISHED
              ? item.shippedQty
              : "—"
        }));
        this.detail = detail;
      } catch (error) {
        this.error = "详情加载失败，请重试";
      } finally {
        this.busy = "";
      }
    },
    showHezhu(row) {
      this.hezhuDetail = String(row.hezhuOrderId);
    },
    createdOrder() {
      this.creating = false;
      this.search();
    },
    hezhuSaved() {
      this.hezhuOrder = null;
      this.fetch();
    },
    openManualRelease(row) {
      this.manualReleaseOrder = row;
      this.manualReleaseForm = { businessId: "", singleWindowNo: "" };
    },
    async manualRelease() {
      const row = this.manualReleaseOrder;
      if (
        !row ||
        this.busy ||
        !this.can("manualRelease") ||
        !this.canDeclare(row)
      )
        return;
      try {
        await this.$confirm("此操作将手工放行核注单，请确认数据正确", "提示", {
          type: "warning"
        });
      } catch (error) {
        return;
      }
      this.busy = "manualRelease";
      try {
        const res = await heZhuApi.manualDeclareSuccess({
          request: {
            id: row.hezhuOrderId,
            businessId: this.manualReleaseForm.businessId,
            singleWindowNo: this.manualReleaseForm.singleWindowNo
          }
        });
        if (!res || res.value !== true)
          throw new Error((res && res.resultMessage) || "手工放行未确认成功");
        this.$message.success("手工放行成功");
        this.manualReleaseOrder = null;
      } catch (error) {
        this.$message.error(
          error.msg || error.message || "手工放行失败，请核实当前状态"
        );
      } finally {
        await this.fetch();
        this.busy = "";
      }
    },
    async declare(row) {
      if (this.busy || !this.can("declare") || !this.canDeclare(row)) return;
      this.busy = "declare";
      try {
        await this.$confirm("此操作将申报核注单，请确认数据正确", "提示", {
          type: "warning"
        });
      } catch (error) {
        this.busy = "";
        return;
      }
      try {
        const res = await heZhuApi.declare({
          heZhuOrderId: row.hezhuOrderId
        });
        if (!res || res.success !== true)
          throw new Error((res && res.resultMessage) || "申报未确认成功");
        this.$message.success("申报成功");
      } catch (error) {
        this.$message.error(
          error.msg || error.message || "申报失败，请核实当前状态"
        );
      } finally {
        await this.fetch();
        this.busy = "";
      }
    },
    async act(row, action, message) {
      if (this.busy || !this.can(action)) return;
      this.busy = action;
      try {
        await this.$confirm(message, "提示", { type: "warning" });
      } catch (error) {
        this.busy = "";
        return;
      }
      this.error = "";
      const id = row.outboundOrderId;
      try {
        const res = await api.outbound[action](id);
        if (!res || res.value !== true)
          throw new Error("操作未确认成功，请刷新核实");
      } catch (error) {
        this.error = error.msg || error.message || "操作结果未知，请刷新核实";
      } finally {
        await this.fetch();
        this.busy = "";
      }
    }
  }
};
</script>
